"use client";

/**
 * NewForm DS hover icon — a tick for "use this".
 * On hover it redraws itself left to right, so the mark reads as being made
 * rather than as already there.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function CheckIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <path className="a-tick" d="m4.8 12.6 4.6 4.6 9.8-10.4" />
    </HoverIconSvg>
  );
}
